/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getGlobalTime = /* GraphQL */ `
  query GetGlobalTime($id: ID!) {
    getGlobalTime(id: $id) {
      id
      ts
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGlobalTimes = /* GraphQL */ `
  query ListGlobalTimes(
    $filter: ModelGlobalTimeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGlobalTimes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ts
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
